module.exports = __webpack_public_path__ + "img/cobrar_qr.724b5b9f.png";